import { isEmbroideryMode } from '@/utils/params';

export const getPrintAreaLabel = () =>
  isEmbroideryMode() ? 'embroidery.labels.printAreas' : 'configuration.basic.printAreas';
